import React, { Component, lazy } from 'react';
import { Switch } from 'react-router-dom';

import { RouteWrapper } from 'components/layout/helper';
import { ROUTES, PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import withSuspense from 'hoc/withSuspense';

const ConfigManager = lazy(() => import('./ConfigManager'));

class ConfigManagerIndex extends Component {
  render() {
    return (
      <Switch>
        <RouteWrapper
          path={ROUTES.CONFIG}
          track={PAGE_VIEW_EVENTS.CONFIG}
          render={withSuspense(ConfigManager)}
        />
      </Switch>
    );
  }
}

export default ConfigManagerIndex;
